import React from 'react';
import { IWizardItem } from '../WizardItem';
import { WizardItemSubtype } from '../../../Enums/WizardItemSubtype.enum';
import WizardVStack from '../WizardVStack/WizardVStack';

interface Props {
	item: IWizardItem;
}

const WizardContainer: React.FC<Props> = ({ item }) => {
	switch (item.subtype) {
		case WizardItemSubtype.V_STACK:
			return <WizardVStack item={item} />;
		default:
			return <>Unsupported container subtype: {item.subtype}</>;
	}
};

export default WizardContainer;